import { Box, Button, TextField } from "@mui/material"

const { useState } = require("react")

export default function QRFindTagId({tagId, onFindTagId}) {

    const [tagIdInput, setTagIdInput] = useState(tagId || '')
    const [tagIdError, setTagIdError] = useState(false)
    const [tagIdHelperText, setIcpNumberHelperText] = useState(' ')

    const handleFindTagClick = async (e) => {
        e.preventDefault()
        onFindTagId(tagIdInput)
    }

    const handleTagIdChange = (event) => {
        const newTagIdInput = event.target.value
        setTagIdInput(newTagIdInput)

        if (newTagIdInput.length !== 10) {
            setTagIdError(true)
            setIcpNumberHelperText('Exactly 10 letters and digits, e.g. Ibl1ThwyCr')
        } else if (!newTagIdInput.match(/^[0-9A-Za-z]+$/)) {
            setTagIdError(true)
            setIcpNumberHelperText('Digits 0-9 or letters a-z A-Z please')
        } else {
            setTagIdError(false)
            setIcpNumberHelperText(' ')
        }
    }

    return (
        <Box className="Page">
            <p>Get Tag Id</p>
            <form onSubmit={handleFindTagClick}>
                <Box sx={{mb: 2}}>
                    <TextField
                        label="ICP Number"
                        value={tagIdInput}
                        error={tagIdError}
                        helperText={tagIdHelperText}
                        onChange={handleTagIdChange} />
                </Box>
                <Button type="submit" variant="contained" onClick={handleFindTagClick} disabled={tagIdError}>Go</Button>
            </form>
        </Box>
    )
}